import { SignUpCompleteUrlKey } from "~/components/popup-container/sign-up-action-redirect/consts";
export const SanitizedUrlKeys = ["onboard", SignUpCompleteUrlKey];
